import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAddCommentText = createSelector(
  [(store: RootState) => store.documentUpdate.commentText],
  (data) => data
);
